import React, {
  createContext,
  useContext,
  useMemo,
} from "react";
import PropTypes from "prop-types";


const WorkspaceNavigationContext =
  createContext(null);


export function WorkspaceNavigationProvider({
  openPanel,
  panelContext,
  children,
}) {
  const value = useMemo(
    () => ({
      openPanel,
      panelContext,
    }),
    [
      openPanel,
      panelContext,
    ],
  );

  return (
    <WorkspaceNavigationContext.Provider
      value={value}
    >
      {children}
    </WorkspaceNavigationContext.Provider>
  );
}


export function useWorkspaceNavigation() {
  const context = useContext(
    WorkspaceNavigationContext,
  );

  if (!context) {
    throw new Error(
      "useWorkspaceNavigation must be used "
      + "inside WorkspaceNavigationProvider.",
    );
  }

  return context;
}


WorkspaceNavigationProvider.propTypes = {
  openPanel: PropTypes.func.isRequired,
  panelContext: PropTypes.object,
  children: PropTypes.node,
};


WorkspaceNavigationProvider.defaultProps = {
  panelContext: null,
  children: null,
};


export default WorkspaceNavigationContext;
